
import { join, concat, printf, toText } from "../../fable_modules/fable-library-js.5.3.0/String.js";
import { sanityThreshold, typicalRange } from "./UnitConfig.js";
import { margin_mt2, gap_gap$002D2, alignItems_itemsStart, display_flex, padding_p4, fontSize_textSm, padding_px3, borderRadius_rounded, border_border, tw } from "../../fable_modules/Feliz.Tailwind.4.0.2/Strings.fs.js";
import { gap_gap2, textColor_textWarning800, borderColor_borderWarning200, backgroundColor_bgWarning50, textColor_textWarning700, borderColor_borderWarning300 } from "../TailwindExtensions.js";
import { singleton, ofArray } from "../../fable_modules/fable-library-js.5.3.0/List.js";
import { compare } from "../../fable_modules/fable-library-js.5.3.0/Decimal.js";
import { defaultOf } from "../../fable_modules/fable-library-js.5.3.0/Util.js";
import { HtmlHelper_createElement } from "../../fable_modules/Feliz.3.3.3/Html.fs.js";
import { createElement } from "react";
import { IconWeight, IconSize, IconName, icon } from "../Icons.js";

function warningText(dailyAverage, unit, activityType) {
    const avgText = toText(printf("%.1f"))(dailyAverage);
    const rangeOpt = typicalRange(activityType, unit);
    if (rangeOpt == null) {
        return concat(avgText, " ", unit, "/day is ambitious!");
    }
    else {
        return `${avgText} ${unit}/day is ambitious! Typical range: ${rangeOpt}.`;
    }
}

const buttonClass = tw(ofArray(["bg-transparent", border_border, borderColor_borderWarning300, textColor_textWarning700, borderRadius_rounded, padding_px3, "py-1", fontSize_textSm]));

/**
 * Renders a sanity check warning if the daily average exceeds the threshold.
 * Returns Html.none if dismissed or if dailyAverage is within the threshold — the component decides visibility.
 * - dailyAverage: totalGoal / duration (caller computes; pass only when inputs are valid)
 * - unit: the selected unit string
 * - activityType: the selected activity value
 * - dismissed: whether the user has dismissed this warning
 * - onKeep: called when "Keep my goal" is clicked
 * - onAdjust: called when "I'll adjust" is clicked (parent should focus the goal input)
 */
export function view(dailyAverage, unit, activityType, dismissed, onKeep, onAdjust) {
    if (dismissed ? true : (compare(dailyAverage, sanityThreshold(activityType, unit)) <= 0)) {
        return defaultOf();
    }
    else {
        return HtmlHelper_createElement("div", ofArray([["role", join(" ", ["alert"])], ["className", tw(ofArray([backgroundColor_bgWarning50, border_border, borderColor_borderWarning200, "rounded-lg", padding_p4]))], ["children", [HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, alignItems_itemsStart, gap_gap$002D2]))], ["children", [HtmlHelper_createElement("span", ofArray([["className", tw(ofArray([textColor_textWarning700, "flex-shrink-0"]))], ["children", [createElement(icon, {
            name: new IconName(34, []),
            size: new IconSize(1, []),
            weight: new IconWeight(1, []),
        })]]])), HtmlHelper_createElement("div", singleton(["children", [HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textWarning800]))], ["children", singleton(warningText(dailyAverage, unit, activityType))]])), HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, gap_gap2, margin_mt2]))], ["children", [HtmlHelper_createElement("button", ofArray([["type", "button"], ["className", buttonClass], ["onClick", (_arg) => {
            onKeep();
        }], ["children", singleton("Keep my goal")]])), HtmlHelper_createElement("button", ofArray([["type", "button"], ["className", buttonClass], ["onClick", (_arg_1) => {
            onAdjust();
        }], ["children", singleton("I\'ll adjust")]]))]]]))]]))]]]))]]]));
    }
}

//# sourceMappingURL=SanityCheckWarning.js.map
